import { render } from "./TextChoice.vue?vue&type=template&id=161f5956&scoped=true"
import script from "./TextChoice.vue?vue&type=script&lang=js"
export * from "./TextChoice.vue?vue&type=script&lang=js"

import "./TextChoice.vue?vue&type=style&index=0&id=161f5956&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-161f5956"

export default script